import React, { Component } from 'react'
import { List } from "utils/ui";
import UserStore from '../stores/UserStore';
export default class ViewPrivateNotes extends Component {
    render() {
        console.log(this.props.notes);

        const listItems = this.props.notes && this.props.notes.length ? this.props.notes.map((note, key) =>
            <div style={{ fontSize: "15px", color: UserStore.theme().darkBackground || "#1f2937", lineHeight: 1.5 }}>
                {note.body}
            </div>) : [];
        return (
            <div className="NoteFont" style={{ 
            padding: '10px',
            maxWidth: '100%',
            margin: '0 auto'
            }}>
            <List
                size="large"
                header={<div style={{ 
                fontSize: "1.25rem", 
                color: UserStore.theme().darkBackground || "#1f2937",
                fontWeight: 700,
                letterSpacing: "0.02em",
                padding: '4px 0 10px 0'
                }}>My Notes About {this.props.user}</div>}
                style={{ 
                background: "rgba(255, 255, 255, 0.78)",
                borderRadius: '14px',
                border: `1px solid ${UserStore.theme().darkBackground || "#d1d5db"}`,
                boxShadow: '0 10px 22px rgba(15, 23, 42, 0.10)',
                overflow: 'hidden'
                }}
                bordered
                dataSource={listItems}
                renderItem={item => (
                <List.Item style={{
                    padding: '12px 14px',
                    borderBottom: '1px solid rgba(15, 23, 42, 0.08)',
                    background: 'rgba(255,255,255,0.45)'
                }}>{item}</List.Item>
                )}
            />
            </div>
        )
    }
}
